export default "__VITE_ASSET__i6wwE7Iv__"